function NXHelp({ className }: { className?: string }) {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4293_1305)">
        <path
          d="M4.92853 12.0001V7.67939C4.94136 6.83008 5.12165 5.99167 5.45907 5.21215C5.79648 4.43264 6.28441 3.72738 6.89486 3.13676C7.50532 2.54615 8.22632 2.08179 9.01655 1.7703C9.80676 1.45881 10.6507 1.30631 11.5 1.32153C12.3492 1.30631 13.1931 1.45881 13.9834 1.7703C14.7736 2.08179 15.4946 2.54615 16.105 3.13676C16.7155 3.72738 17.2035 4.43264 17.5409 5.21215C17.8782 5.99167 18.0586 6.83008 18.0714 7.67939V12.0001"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.46427 9.5358H4.10713C4.32498 9.5358 4.53392 9.62234 4.68796 9.77639C4.84201 9.93043 4.92855 10.1394 4.92855 10.3572V15.2858C4.92855 15.5037 4.84201 15.7126 4.68796 15.8666C4.53392 16.0207 4.32498 16.1072 4.10713 16.1072H2.46427C2.02855 16.1072 1.61069 15.9341 1.30259 15.626C0.994498 15.3179 0.821411 14.9001 0.821411 14.4644V11.1787C0.821411 10.7429 0.994498 10.3251 1.30259 10.017C1.61069 9.70889 2.02855 9.5358 2.46427 9.5358Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5357 16.1072H18.8928C18.675 16.1072 18.466 16.0207 18.3119 15.8666C18.158 15.7126 18.0714 15.5037 18.0714 15.2858V10.3572C18.0714 10.1394 18.158 9.93043 18.3119 9.77639C18.466 9.62234 18.675 9.5358 18.8928 9.5358H20.5357C20.9714 9.5358 21.3893 9.70889 21.6974 10.017C22.0054 10.3251 22.1786 10.7429 22.1786 11.1787V14.4644C22.1786 14.9001 22.0054 15.3179 21.6974 15.626C21.3893 15.9341 20.9714 16.1072 20.5357 16.1072Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7857 20.6251C15.6571 20.6251 16.4928 20.2789 17.109 19.6627C17.7253 19.0464 18.0714 18.2107 18.0714 17.3393V13.6429"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7857 20.6251C14.7857 21.1697 14.5694 21.6921 14.1842 22.0772C13.7991 22.4623 13.2768 22.6786 12.7322 22.6786H10.2679C9.72323 22.6786 9.2009 22.4623 8.81578 22.0772C8.43066 21.6921 8.21429 21.1697 8.21429 20.6251C8.21429 20.0805 8.43066 19.558 8.81578 19.173C9.2009 18.7879 9.72323 18.5715 10.2679 18.5715H12.7322C13.2768 18.5715 13.7991 18.7879 14.1842 19.173C14.5694 19.558 14.7857 20.0805 14.7857 20.6251Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4293_1305">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500061)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXHelp